var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraFlip = function SvgCameraFlip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    className: "camera-flip_svg__no-fill-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 27",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2H7v14h20V2h-5l-1-2h-8l-1 2Zm5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm5-9h3v2h-3V4Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.137c-6.9-.833-12-3.77-12-7.264 0-1.632 1.112-3.142 3-4.373m21 10.87c4.782-1.297 8-3.72 8-6.497 0-1.632-1.112-3.142-3-4.373",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13 18.373 8 4-8 4v-8Z",
    fill: "#fff"
  })));
};
export default SvgCameraFlip;